import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
// middlewares
import VisitScheduleMiddleware from "../../../../middleware/modules/sales/visit-schedule";
import { Button, Modal } from "react-bootstrap";
import { Helmet } from "react-helmet";
import i18n from "../../../../i18n";
import FormUpdate from "../../../../components/modules/sales/visit-schedule/formUpdate";
import FormChange from "../../../../components/modules/sales/visit-schedule/formChange";

const mapStateToProps = ({ auth, visitSchedule}) => ({
  isAuthenticated: auth.isAuthenticated,
  ...visitSchedule
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      closeModal: () => VisitScheduleMiddleware.closeModal(),
      new: (data) => VisitScheduleMiddleware.beforeSaveNew(data),
      changeSales: (data, search) => VisitScheduleMiddleware.beforeSaveChange(data, search),
    },
    dispatch
  );
};
class FormChangeContainer extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    isSuccess: PropTypes.bool,
    dataUpdate: PropTypes.object,
    errorMessage: PropTypes.any,
    onSubmit: PropTypes.bool,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isSuccess: false,
    isError: false,
    errorMessage: [],
    dataUpdate: null,
    onSubmit: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      modal: {
        title: "",
        show: false,
      },
    };
    this.form = React.createRef();
    this.getData = this.getData.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.close = this.close.bind(this);
  }

  getData() {
    return this.props.showOne(this.props.dataID);
  }

  close() {
    this.props.closeModal();
  }

  submitForm() {
    const {search, isNewRecord, dataUpdate } = this.props;
    var form = this.form.current.runSubmit();
    this.props.changeSales(form, search);
  }

  render() {
    const {
      onSubmit,
      showModalChange,
      titleModal,
      viewData
    } = this.props;
    return (
      <>
        <Modal show={showModalChange} size={"lg"}>
          <Modal.Header>
            <Modal.Title>{titleModal}</Modal.Title>
          </Modal.Header>
          <Helmet>
            <title>{titleModal}</title>
          </Helmet>
          <Modal.Body>
            {<FormChange
              {...this.props}
              ref={this.form}
            />}
           
          </Modal.Body>
          <Modal.Footer className={(!onSubmit)?"justify-content-between":"justify-content-center"}>
            {onSubmit ? (
              ""
            ) : (
              <Button variant="secondary" onClick={() => this.close(false)}>
                {i18n.t("Close")}
              </Button>
            )}
            <Button variant="primary" onClick={() => ((onSubmit)?false:this.submitForm(true))}>
              {onSubmit ? (
                <span className="indicator-progress show">
                  {i18n.t("Please wait...")}
                  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                </span>
              ) : (
                <span className="indicator-label">{i18n.t("Save")}</span>
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FormChangeContainer);
